const serviceID = process.env.REACT_APP_SERVICE_ID;
const templatecontactformID = process.env.REACT_APP_TEMPLATE_CONTACTFORM_ID;
const templatesubscribenewsletter = process.env.REACT_APP_TEMPLATE_SUBSCRIBENEWSLETTER_ID;
const publicKey = process.env.REACT_APP_PUBLIC_KEY;

export { serviceID, templatecontactformID, publicKey, templatesubscribenewsletter };